import React, { useState } from 'react';
import { FolderIcon, FolderPlusIcon } from '../icons';

const MyFoldersMenu = ({ 
  folders = [],
  currentFolderId = null,
  onFolderSelect = () => {},
  onNewFolder = () => {},
  className = ''
}) => {
  const [isCreatingNew, setIsCreatingNew] = useState(false);
  const [newFolderName, setNewFolderName] = useState('');

  const handleNewFolderClick = () => {
    setIsCreatingNew(true);
    setNewFolderName('');
  };

  const handleNewFolderSubmit = (e) => {
    e.preventDefault();
    if (newFolderName.trim() && onNewFolder) {
      onNewFolder(newFolderName.trim());
      setIsCreatingNew(false);
      setNewFolderName('');
    }
  };

  const handleNewFolderCancel = () => {
    setIsCreatingNew(false);
    setNewFolderName('');
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Escape') {
      handleNewFolderCancel();
    } else if (e.key === 'Enter') {
      handleNewFolderSubmit(e);
    }
  };

  return (
    <div className={`w-full ${className}`}>
        {/* Title */}
        <div className="mb-3">
            <h3 className="text-[11px] font-medium text-[#7B7B7B] dark:text-[#848484] leading-4 tracking-[-0.1px]">
              Recent
            </h3>
        </div>

        {/* Menu Items */}
        <div className="space-y-[8px]">
            {/* New Folder Item */}
            <div 
              className="w-full h-[38px] rounded-xl cursor-pointer transition-all duration-200 hover:bg-[#F1F1F1] dark:hover:bg-[#2A2A2A]"
              onClick={handleNewFolderClick}
            >
              <div className="flex items-center h-full p-2">
                  {/* Icon Container */}
                  <div 
                    className="w-8 h-8 flex items-center justify-center mr-3"
                  >
                  <FolderPlusIcon 
                      size={20} 
                      className="text-[#7B7B7B] dark:text-[#848484]" 
                      fill="none"
                  />
                  </div>
                  
                  {/* Text */}
                  <span className="text-xs font-semibold text-[#121212] dark:text-[#D0D0D0] leading-4 tracking-[-0.1px]">
                  New Folder
                  </span>
              </div>
            </div>

            {/* New Folder Creation State */}
            {isCreatingNew && (
            <div className="w-full h-[38px] rounded-xl border bg-[#F1F1F1] dark:bg-[#2A2A2A] border-[#ECECEC] dark:border-[#202020]">
                <div className="flex items-center h-full p-2">
                    {/* Icon Container */}
                    <div className="w-8 h-8 flex items-center justify-center mr-3">
                      <FolderIcon 
                          size={20} 
                          className="text-[#7B7B7B] dark:text-[#848484]"
                          fill="rgba(36, 81, 228, 0.2)"
                      />
                    </div>
                    
                    {/* Input Field */}
                    <div className="flex items-center flex-1">
                      {/* Input */}
                      <input
                          type="text"
                          value={newFolderName}
                          onChange={(e) => setNewFolderName(e.target.value)}
                          onKeyDown={handleKeyDown}
                          onBlur={handleNewFolderSubmit}
                          placeholder="Untitled Folder"
                          className="text-xs font-semibold leading-4 tracking-[-0.1px] bg-transparent border-none outline-none flex-1 text-[#7B7B7B] dark:text-[#848484] placeholder:text-[#7B7B7B] dark:placeholder:text-[#848484]"
                          autoFocus
                      />
                    </div>
                </div>
            </div>
            )}

            {/* Existing Folders */}
            {folders.map((folder, index) => (
              <div 
                key={folder.id || index}
                className={`w-full h-[38px] rounded-xl cursor-pointer transition-all duration-200 hover:bg-[#F1F1F1] ${currentFolderId === folder.id ? 'bg-[#F1F1F1] dark:bg-[#2A2A2A]' : ''} dark:hover:bg-[#2A2A2A]`}
                onClick={() => onFolderSelect(folder)}
              >
                <div className="flex items-center h-full p-2">
                  {/* Icon Container */}
                  <div 
                  className="w-8 h-8 flex items-center justify-center mr-3"
                  >
                  <FolderIcon 
                      size={20} 
                      color={folder.color || "rgb(123, 123, 123)"}
                      fill={folder.fillColor || "rgba(123, 123, 123, 0.2)"}
                  />
                  </div>
                  
                  {/* Text */}
                  <span className="text-xs font-semibold text-[#121212] dark:text-[#D0D0D0] leading-4 tracking-[-0.1px]">
                    {folder.name}
                  </span>
                </div>
              </div>
            ))}

        </div>

    </div>
  );
};

export default MyFoldersMenu;
